module.exports = __webpack_public_path__ + "static/img/empty_card.78cd706.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty_card.png
// module id = VMYO
// module chunks = 1